export default {
    showVariationsModal: {
        copy: 'Kopieren',
        contentVariation: 'Inhaltliche Variation',
        chosenContent: 'Ausgewählter Inhalt',
        chosenContentPlaceholder: 'Bitte eingeben',
        continue: 'Weiter',
        generateNewContent: 'Neuen Inhalt generieren',
        type: 'Art:',
        contentTitle: 'Titel:',
        descriptionLabel: 'Beschreibung:',
        keywordsLabel: 'Schlüsselwörter:',
        writingTone: 'Schreibstil:',
        context: 'Kontext:',
        cancel: 'Abbrechen',
        emailBuilderTooltip: 'Custom values for sender and recipient is added in the content.',
    },
};
